// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wVSaJnGO3kTVKPGQ4Xqn{font-size:16px;height:16px;line-height:31px;width:16px;color:var(--neutralSecondary)!important}html[dir=ltr] .wVSaJnGO3kTVKPGQ4Xqn{margin-left:16px;margin-right:12px}html[dir=rtl] .wVSaJnGO3kTVKPGQ4Xqn{margin-right:16px;margin-left:12px}html[dir] .AfTXMusDRHwCl539mqDe{padding-bottom:16px}html[dir] .e9IWm3TaQjUwP5zECfWX{padding-bottom:14px}html[dir] .WncIaUGgsroQzEBj0Sh7{padding-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconRoot": "wVSaJnGO3kTVKPGQ4Xqn",
	"iconRootComputer": "AfTXMusDRHwCl539mqDe",
	"iconRootCloud": "e9IWm3TaQjUwP5zECfWX",
	"iconRootUploadAndShare": "WncIaUGgsroQzEBj0Sh7"
};
module.exports = ___CSS_LOADER_EXPORT___;
